module.exports = __webpack_public_path__ + "img/horse1.31b58613.svg";